import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import DriverCommissionsDetailCtrl from '../../../components/reportsComponents/drivermanagement/driverCommissionsDetailCtrl';
import DriverCommissionsDetailTable from '../../../components/reportsComponents/drivermanagement/driverCommissionsDetailTable';
const pageTitle = 'Driver Commission'
let DriverCommissionsDetailForm={
	formDriverCommissionsDetailInfo:{}
}

class DriverCommissionsDetail extends Component {
	constructor() {
		super();
		this.state = {
            fromDate:'',
            toDate:''
		}
	}
	componentWillMount = () => {
		document.title = pageTitle;
		
    }
    onDriverCommissionsDetailFieldChange=(key, value)=>{
        this.setState({[key]:value});
    }
	render() {
		return (
            <Fragment>
                <div className="page-header">
                    <div className="row mb-10">
                        <div className="col-md-12 col-sm-12">
                            <div className="title">
                                <h4> Driver Commission</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pd-10 bg-white border-radius-4 box-shadow">
                    <DriverCommissionsDetailCtrl onDriverCommissionsDetailFieldChange={(key, value)=>this.onDriverCommissionsDetailFieldChange(key, value)}
                    initCallBack={(frm)=>{
						DriverCommissionsDetailForm.formDriverCommissionsDetailInfo=frm;
                    }} fromdate={this.state.fromDate} todate={this.state.toDate}/>
                    <DriverCommissionsDetailTable />
                </div>
            </Fragment>
		);
	}
}
const mapStateToProps = (state, ownProps) => {
	return {
		
	}
};

export default withRouter(connect(mapStateToProps)(DriverCommissionsDetail));
